module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1050-84cad919b4d25da5c170a15dbf051a13.png";